export const iconFontAwesomeBuildingsOilWell = (
	<i className="fa-solid fa-oil-well"></i>
);
